/*
Ashraf 01/12/2023 2699710829 map client code with audit list popup
Ashraf 01/12/2023 2699710829 filtered active options for audit list.
suresh peddavoora 02/21/2023 2699710829 new UI changes for texfields and tables alignments
Rohini 03/01/2023 2699710829 worked on the code enhancements.
Akhila 04/19/2023 2699710829  modified client code dropDownData data
Ravi 06/22/2023 2699710829 fixed submit issue
Sohel 10/11/2023 2699710829 Fixed Role Access Issue
*/
import React, {useContext, useEffect, useState} from 'react';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {Formik} from 'formik';
import {
  Button,
  FormHelperText,
  Grid,
} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useSelector} from 'react-redux';
import DialogBox from './../../../../../components/DialogBox/index';
// import SearchEventTactics from "../../Triggers/AddTrigger/AddClient/SearchEventTactics";
import {ArrowBack} from '@material-ui/icons';
import {getClientCodeDropDownData} from '../../../../../redux/reducers/TriggerGroup';
import {useDispatch} from 'react-redux';
import SearchFieldList from '../../../GlobalFields/GlobalFieldList/SearchFieldList';
import {
  postClientAuditList,
} from '../../../../../redux/reducers/GlobalField/ClientAuditList';
import PageLoader from '../../../../../components/PageLoader';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

// import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
// import GuiTextField from '../../../../components/FormComponents/GuiTextField';
const AddClientAuditForm = ({
  isEdit,
  setIsEdit,
  AttachedTriggersData,
  setAttachedTriggersData,
  setOpenPopup,
  clientRowData,
  unique,
  setUnique,
  eventType,
  eventCode,
  eventDescription,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const {isLoading, clientListData, auditListData} = useSelector(
    ({auditFieldList}) => auditFieldList,
  );
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [searchEventTactics, setSearchEventTactics] = useState(false);
  const [selectedList, setSelectedList] = useState([]);
  const [auditOptions, setAuditOptions] = useState([]);
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Client Audit Field List']?.['CAFL'];
  const handleEventTacticSearch = () => {
    setSearchEventTactics(false);
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.clientNumber === option || item?.fieldListCode === option) {
          label = item;
        }
      });
    return label;
  };

  const initialValues = {
    clientCode:
      isEdit && clientListData?.clientNumber ?
        getObject(clientListData?.clientNumber, clientCodeDropdownData) :
        {},
    auditList:
      isEdit && clientListData?.auditfieldsList ?
        getObject(clientListData?.auditfieldsList, auditOptions) :
        '',
    isDefault: isEdit && clientListData && clientListData.isDefault === 'Y' ? true : false,
  };

  useEffect(() => {
    setSelectedList(
      isEdit && clientListData ? [{fieldListCode: clientListData?.auditfieldsList}] : [],
    );
  }, [isEdit, clientListData]);

  const schema = Yup.object().shape({
    clientCode: Yup.mixed().test('clientCode', 'Client Code is required', (value) => {
      if (!value?.clientName) {
        return false;
      } else {
        return true;
      }
    }),
    auditList: Yup.mixed().test('auditList', 'Audit List is required', (value) => {
      if (value?.fieldListCode) {
        return true;
      } else {
        return false;
      }
    }),
  });


  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const data = {
      clientNumber: values?.clientCode?.clientNumber ? values?.clientCode?.clientNumber : '',
      auditfieldsList: values?.auditList?.fieldListCode ? values?.auditList?.fieldListCode : '',
      clientAuditId: clientListData?.clientAuditId ? clientListData?.clientAuditId : 0,
    };
    dispatch(postClientAuditList(data));
    // const copyData = [...AttachedTriggersData];
    // if (!isEdit) {
    //     copyData.push({ ...data });
    //     const cleanArray = copyData.reduce((unique, o) => {
    //         if (
    //             !unique.some(
    //                 (obj) =>
    //                     obj?.clientCode === o?.clientCode && obj?.type === o?.type && obj?.eventTactic[0]?.code === o?.eventTactic[0]?.code
    //             )
    //         ) {
    //             unique.push(o);
    //         }
    //         return unique;
    //     }, []);
    //     if (copyData?.length > cleanArray?.length) {
    //         setUnique(true);
    //     } else {
    //         setAttachedTriggersData(cleanArray);
    //         setOpenPopup(false);
    //     }
    // } else {
    //     const updatedData = copyData.map((each, i) => {
    //         const { tableData } = clientRowData;
    //         if (each.tableData?.id === tableData?.id) {
    //             return {
    //                 ...each,
    //                 clientCode: data?.clientCode || "",
    //                 correspondingClients: data?.correspondingClients,
    //                 eventTactic: data?.eventTactic ? data?.eventTactic : [],
    //                 type: data?.type ? data?.type : "",
    //             };
    //         } else {
    //             return {
    //                 ...each,
    //             };
    //         }
    //     });
    //     const cleanArrays = updatedData.reduce((unique, o) => {
    //         if (
    //             !unique.some(
    //                 (obj) =>
    //                     obj?.clientCode === o?.clientCode && obj?.type === o?.type && obj?.eventTactic[0]?.code === o?.eventTactic[0]?.code
    //             )
    //         ) {
    //             unique.push(o);
    //         }
    //         return unique;
    //     }, []);
    //     if (copyData?.length > cleanArrays?.length) {
    //         setUnique(true);
    //         setdisabled(true);
    //     } else {
    //         setAttachedTriggersData(updatedData);
    //         setIsEdit(false);
    //     }
    // }
  };
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setUnique && setUnique(false);
      ``;
    }, 2500);
  }, [unique]);

  useEffect(() => {
    let ops = [];
    if (auditListData && auditListData?.length > 0) {
      ops = auditListData?.filter((i) => {
        return i?.isActive === 'Y';
      });
    }
    setAuditOptions(ops);
  }, [auditListData]);

  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,

                handleSubmit,
                setFieldValue,
                handleReset,
                touched,
                errors,
                resetForm,
              } = props;
              return (
                <>
                  {searchEventTactics ? (
                    <>
                      <DialogBox
                        open={searchEventTactics}
                        dialogClose={() => handleEventTacticSearch()}
                        title="Select Audit List"
                        maxWidth="lg"
                      >
                        <div className="col-12">
                          <Button
                            variant="text"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              setSearchEventTactics(false);
                            }}
                          >
                            <ArrowBack className="mr-2" />
                            Go Back
                          </Button>
                        </div>
                        {/* <SearchEventTactics
                                                    handleClose={handleEventTacticSearch}
                                                    setSelectedEventTrigger={setSelectedEventTrigger}
                                                    selectedEventTrigger={selectedEventTrigger}
                                                    isEventTriggerGroup={true}
                                                    eventType={eventType}
                                                    cardSpace={cardSpace}
                                                    searchEventTactics={searchEventTactics}
                                                    setSearchEventTactics={setSearchEventTactics}
                                                /> */}
                        <SearchFieldList
                          handleClose={handleEventTacticSearch}
                          selectedList={selectedList}
                          setSelectedList={setSelectedList}
                          AuditFieldList={true}
                          StepperFieldList={true}
                        />
                      </DialogBox>
                    </>
                  ) : (
                    <>
                      <div>
                        {/* <BreadCrums
                                                    name={" Event Trigger Code"}
                                                    code={eventCode}
                                                    description={" Event Trigger Description"}
                                                    descriptionValue={eventDescription}
                                                /> */}
                        <form
                          autoComplete="off"
                          noValidate
                          onSubmit={handleSubmit}
                          onReset={handleReset}
                        >
                          <div className="global-field-textfields new-standard-textfields">
                            <ErrorBoundaryForComponents>
                              <Grid container spacing={2}>
                                <Grid item xs={6} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="clientCode"
                                    id="clientCode"
                                    size="small"
                                    value={values.clientCode}
                                    options={
                                      clientCodeDropdownData?.length > 0 ?
                                        clientCodeDropdownData :
                                        []
                                    }
                                    // disabled={isDisabledBaseCategory.current && selectedRows?.length > 0}
                                    getOptionLabel={(option) => {
                                      return option && option.clientName ? option.clientName : '';
                                    }}
                                    onChange={(e, value) => {
                                      setFieldValue('clientCode', value);
                                    }}
                                    placeholder="Select Client Code"
                                    required
                                    disabled={isEdit && clientListData?.clientNumber}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          className={`${classes.labelName}`}
                                          {...params}
                                          error={touched.clientCode && errors.clientCode}
                                          variant="outlined"
                                          margin="dense"
                                          // InputLabelProps={{
                                          //     shrink: true,
                                          // }}
                                          required
                                          label="Client Code"
                                          placeholder="Select Client Code"
                                        />
                                        <FormHelperText>
                                          {touched.clientCode &&
                                            errors.clientCode &&
                                            errors.clientCode}
                                        </FormHelperText>
                                      </div>
                                    )}
                                  />
                                </Grid>
                                {/* <Grid item xs={6} className="form-group">
                                                                    <TextField
                                                                        margin="dense"
                                                                        className={`${classes.labelName} ${classes.inputLabel}`}
                                                                        variant="outlined"
                                                                        placeholder={`Select Audit List`}
                                                                        label="Audit List"
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                        }}
                                                                        name="auditList"
                                                                        value={getEventTriggerData(selectedList)}
                                                                        onChange={(e) => {
                                                                            handleChange(e);
                                                                            setFieldValue("auditList", e.target.value);
                                                                        }}
                                                                        fullWidth
                                                                        handleBlur={handleBlur}
                                                                        required
                                                                        touched={touched?.auditList}
                                                                        error={
                                                                            selectedList?.length > 0
                                                                                ? null
                                                                                : Boolean(touched?.auditList && errors?.auditList)
                                                                        }
                                                                        disabled
                                                                        InputProps={{
                                                                            endAdornment: (
                                                                                <InputAdornment position="end">
                                                                                    <Tooltip title={"Search"}>
                                                                                        <Search
                                                                                            className={` ${classes.iconSearch}`}
                                                                                            onClick={() => {
                                                                                                setCardSpace(true);
                                                                                                setSearchEventTactics(true);
                                                                                            }}
                                                                                            size="sm"
                                                                                        />
                                                                                    </Tooltip>
                                                                                    <Tooltip title={"Clear"}>
                                                                                        <Clear
                                                                                            className={` ${classes.iconSearch}`}
                                                                                            onClick={(e) => setSelectedList([])}
                                                                                        />
                                                                                    </Tooltip>
                                                                                </InputAdornment>
                                                                            ),
                                                                        }}
                                                                    />
                                                                    <FormHelperText style={{ color: "red" }}>
                                                                        {selectedList?.length > 0
                                                                            ? null
                                                                            : touched?.auditList && errors?.auditList}
                                                                    </FormHelperText>
                                                                </Grid> */}
                                {/* <Grid item xs={6} className="form-group">
                                                                    <FormControl component="fieldset">
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    onChange={(e, value) => {
                                                                                        handleChange(e);
                                                                                        setFieldValue("isDefault", e.target.checked);
                                                                                    }}
                                                                                    // disabled={values?.auditNote}
                                                                                    name="isDefault"
                                                                                    checked={values?.isDefault}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label="Set as default"
                                                                            labelPlacement="end"
                                                                        />
                                                                    </FormControl>
                                                                </Grid> */}
                                <Grid item xs={6} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="auditList"
                                    id="auditList"
                                    size="small"
                                    value={values.auditList}
                                    options={auditOptions}
                                    // disabled={isDisabledBaseCategory.current && selectedRows?.length > 0}
                                    getOptionLabel={(option) => {
                                      return option && option?.fieldListDesc ?
                                        option?.fieldListCode === null ?
                                          option?.fieldListDesc :
                                          option?.fieldListCode + ' - ' + option?.fieldListDesc :
                                        '';
                                    }}
                                    onChange={(e, value) => {
                                      setFieldValue('auditList', value);
                                    }}
                                    placeholder="Select Audit List"
                                    required
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          className={`${classes.labelName}`}
                                          {...params}
                                          error={touched.auditList && errors.auditList}
                                          variant="outlined"
                                          margin="dense"
                                          // InputLabelProps={{
                                          //     shrink: true,
                                          // }}
                                          required
                                          label="Audit List"
                                          placeholder="Select Audit List"
                                        />
                                        <FormHelperText>
                                          {touched.auditList &&
                                            errors.auditList &&
                                            errors.auditList}
                                        </FormHelperText>
                                      </div>
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </ErrorBoundaryForComponents>
                          </div>
                          <div className="d-flex justify-content-center new-standard-textfields">
                            <Button
                              variant="outlined"
                              onClick={() => {
                                resetForm(initialValues);
                                setSelectedList(
                                  isEdit && clientListData ?
                                    [{fieldListCode: clientListData?.auditfieldsList}] :
                                    [],
                                );
                              }}
                              disbled={!disable?.add}
                              className={`mx-1 reset-btn ${classes.buttonRoot}`}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              disabled={(!disable?.add) || enabledSubmission}
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                        {isLoading && <PageLoader />}
                      </div>
                    </>
                  )}
                </>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default AddClientAuditForm;
